import { DocumentNode } from 'graphql';
import { gql, MutationHookOptions, useMutation } from '@apollo/client';
import { ICompanySchemaPartial } from '../../type/company';
import { ITranslationSubTypeInput } from '../../type/_inputTypes/translation';

export interface IUpdateCompanyProfileMutationFields {
  _id: string;
  status: boolean
  verification: boolean
  active: boolean
  name: ITranslationSubTypeInput[]
  aka?: ITranslationSubTypeInput[]
  uen?: string
  origin: string
  slogan: ITranslationSubTypeInput[]
  profile: ITranslationSubTypeInput[]
  businessType: number[]
  incorporateDate?: number
  workforceNumber?: number
  annualRevenue?: number
  salesRatioPercentage?: number
  uploadedProfileImageIds?: string[];
}


export interface IUpdateCompanyProfileMutationResponseFields {
  updatedCompany: ICompanySchemaPartial;
}


export function updateCompanyProfileMutation(fragment: string): DocumentNode {
  return gql`
        mutation updateCompanyProfile (
        $_id: String!,
$status: Boolean,
$verification: Boolean,
$active: Boolean,
$name: [TranslationSubTypeInput]!,
$aka: [TranslationSubTypeInput],
$uen: String,
$origin: String!,
$slogan: [TranslationSubTypeInput],
$profile: [TranslationSubTypeInput],
$businessType: [Int],
$incorporateDate: Int,
$workforceNumber: Int,
$annualRevenue: Float,
$salesRatioPercentage: Float,
$uploadedProfileImageIds: [String]
        ) {
        updateCompanyProfile (
        _id: $_id,
status: $status,
verification: $verification,
active: $active,
name: $name,
aka: $aka,
uen: $uen,
origin: $origin,
slogan: $slogan,
profile: $profile,
businessType: $businessType,
incorporateDate: $incorporateDate,
workforceNumber: $workforceNumber,
annualRevenue: $annualRevenue,
salesRatioPercentage: $salesRatioPercentage,
uploadedProfileImageIds: $uploadedProfileImageIds
        ) {
        ...fragment
        }
        }
        fragment fragment on UpdateCompanyProfileMutationResponse {
        code
        success
        message
        ${fragment}
        }
    `;
}

export function useUpdateCompanyProfileMutation<TData extends Partial<IUpdateCompanyProfileMutationResponseFields>>(
  fragment: string, options?: MutationHookOptions<{ updateCompanyProfile: TData },
        IUpdateCompanyProfileMutationFields>,
) {
  return useMutation<{ updateCompanyProfile: TData },
      IUpdateCompanyProfileMutationFields>(
        updateCompanyProfileMutation(fragment), options,
      );
}
